import Vue from 'vue'
import Template from './template'
Vue.component('g-icon', Template)
